import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { BookServiceService } from "src/app/services/book-service.service";

@Component({
  selector: "app-all-books",
  templateUrl: "./all-books.component.html",
  styleUrls: ["./all-books.component.scss"]
})
export class AllBooksComponent implements OnInit {
  image: any;
  rate: any;
  id: any;
  constructor(private Book: BookServiceService) {}
  data: {};
  title: any;
  description: any;

  AdminBooks: any;
  sub: Subscription;

  ngOnInit() {
    this.sub = this.Book.allBooks().subscribe(data => {
      this.AdminBooks = data.map(el => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });
    });
  }

  remove(id) {
    this.Book.removeBook(id).catch(err => console.log(err));
  }
  onOpen(id: string) {
    this.Book.getBook(id).then(data => {
      this.title = data.title;
      this.description = data.description;
      this.image = data.image;
      this.rate = data.rate;
    });
  }
  done(id) {
    this.Book.ediBook(id)
      .update({
        title: this.title,
        description: this.description,
        image: this.image,
        rate: this.rate
      })
      .then(data => {});
  }
}
